import React from 'react';
import BaseButton from "../BaseButton/BaseButton";
import {buttonTheme} from "../BaseButton/buttonTheme";
import BaseInput from "../BaseInput/BaseInput";


export default function AhamoveIdInfo({parentId, childIdList, onClickConfirm}) {
    let childList = []
    try {
        childList = childIdList.reduce((sumString, child) => sumString + ', ' + child);
    } catch {
        childList = 'Không tìm thấy id con'
    }
    return (
        <div className={'py-3'}>
            <div className={'flex flex-col justify-between items-center flex-wrap'}>
                <div className={'font-semibold flex-1'}>Chon thêm ID tài khoản con của bạn</div>
                <div className={'w-full p-2 bg-slate-100 text-sm'}>ID TÀI KHOẢN MẸ</div>
                <div className={'w-full p-2 font-bold'}>
                    {parentId}
                </div>
                <div className={'w-full p-2 bg-slate-100 text-sm'}>ID TÀI KHOẢN CON</div>
                <div className={'w-full p-2 font-bold flex justify-start'}>
                    {childList}
                </div>
                <div className={'w-full p-2 bg-slate-100 text-sm'}>
                    Lưu ý: Bạn có thể quản lý thêm các ID con trong mục nhân viên ở màn hình profile
                </div>
                <div className={'w-full p-2'}>
                    <BaseButton onClick={onClickConfirm} buttonStyle={buttonTheme.confirm} label={'Xác nhận'}/>
                </div>
            </div>
        </div>
    );
}
